import { ReactElement } from 'react';
import { RouteData } from '@sitecore-jss/sitecore-jss-nextjs';

import { getComponentProps } from '@gn-audio/jss-core';

import { SearchMenuFields } from '../../types';
import { LanguageSelector, LanguageSelectorProps } from '../LanguageSelector/LanguageSelector';
import { LanguageSelectorButton } from '../LanguageSelector/LanguageSelectorButton';
import { SearchButton } from '../Search';
import { Search } from '../Search/components/Search';
import { SubmenuId } from './megaMenuTypes';

export enum HeaderComponentName {
  Search = 'Search',
  LanguageSelector = 'LanguageSelector',
}

export const submenuComponentsMap: Record<
  SubmenuId | string,
  (route: RouteData) => ReactElement | null
> = {
  LanguageSelector: (route) => {
    const languageRenderingFields = getComponentProps(
      route.placeholders,
      HeaderComponentName.LanguageSelector
    )?.fields as unknown as LanguageSelectorProps['fields'];

    return <LanguageSelector fields={languageRenderingFields} />;
  },
  Search: (route) => {
    const searchFields = getComponentProps(route.placeholders, HeaderComponentName.Search)
      ?.fields as SearchMenuFields;

    return <Search fields={searchFields} isDropdown />;
  },
};

export const menuComponentsMap: Record<
  SubmenuId,
  (onClick: () => void, isActive?: boolean) => ReactElement
> = {
  LanguageSelector: (onClick, isActive) => {
    return <LanguageSelectorButton onClick={onClick} isActive={isActive} />;
  },
  Search: (onClick, isActive) => {
    return <SearchButton onClick={onClick} isActive={isActive} />;
  },
};
